<template>
  <div id="app">
    <router-view v-if="isRouterAlive"  :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },

  created() {
  },

  methods: {

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
}
</script>

<style>
@import url('./assets/css/elementui.css');
@import url('./assets/css/common.css');
@import url('./assets/css/variable.css');
@import url('./assets/css/flex.css');
body{
  word-break: normal;         /* 单词不切开（优先整词换行） */
  word-wrap: break-word;     /* 超长单词强制换行 */
  overflow-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/App.vue